export default "__VITE_ASSET__ByMdqSE___"